import React from "react";
import { NavLink, useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { MobileTopHeader } from "../../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import SelectedItemFromCategoryInside from "../../../../../../vendorDashboardComponents/ItemAvailability/AddItemFromCateloge/SelectedItemFromCategoryInside";
import Media from "react-media";

function OnboardSelectedItemFromCategory(props) {
  let history = useHistory();

  const onActionBackClick = (e) => {
    e.preventDefault();
    if (history.location.state.includes("/fastfood/menusetup/additem")) {
      history.push("/fastfood/menusetup");
    } else if (
      history.location.state.includes("/multi-service/menusetup/additem")
    ) {
      history.push("/multi-service/menusetup");
    } else {
      history.push("/casual-fine-dining/menusetup");
    }
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <Media query="(min-width: 992px)">
            <div className="col-6">
              <BackLogoIconButton
                displayBackText={true}
                workWithLinkORClick={true}
                displayArrow={true}
                backButtonClicked={
                  (e) => onActionBackClick(e)
                  // "/casual-fine-dining/menusetup/selectmenu/selectedcategories"
                }
                notDisplaProgressBar={true}
              />
            </div>
          </Media>
          <Media query="(max-width: 991px)">
            <MobileTopHeader
              link={false}
              onClick={
                (e) => onActionBackClick(e)
                // "/casual-fine-dining/menusetup/selectmenu/selectedcategories"
              }
              notDisplaProgressBar={true}
            />
          </Media>

          <div className="col-6 loginsignup-rightside bg-transparent min-height-auto">
            <div className="row">
              <div className="col-12 login-section-one">
                <div className="login-top-right-nav">
                  <NavLink to="/">
                    <i
                      className="fa fa-question-circle-o"
                      aria-hidden="true"
                    ></i>
                  </NavLink>
                </div>
                <div className="login-top-right-nav margin-hamburgur">
                  <NavLink to="/">
                    <i className="fa fa-bars" aria-hidden="true"></i>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          >
            <div className="onboarding_process_screen-button-map">
              <div>
                <SelectedItemFromCategoryInside />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <Container fluid>
              <div className="super-admin-inside-right-side-panel">
                {/* <SelectItemsNew dash={true} /> *
                <SelectedItemFromCategoryInside />
              </div>
            </Container>
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </div> */}
    </React.Fragment>
  );
}

export default OnboardSelectedItemFromCategory;
